module.exports = __webpack_public_path__ + "img/tx.4f443be8.png";